

import api from '../../utils/api';

/**
 * @param {object} record 
 */
export function setupPaymentApi(record) {
    return api
        .post(`/payments/collectPayment`, record)
        .then(response => response.data)
        .catch(error => Promise.reject(error));
}

export function checkIsValid(record) {
    return api
        .post(`/rest/payments/is-already-paid`, record)
        .then(response => response.data)
        .catch(error => Promise.reject(error));
}
